'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Blog } from '@/types';
import { resolveImageUrl } from '@/lib/image';

export const BlogPostView: React.FC<{ blog: Blog }> = ({ blog }) => {
    const { i18n } = useTranslation();
    const title = i18n.language === 'de' && blog.title_de ? blog.title_de : blog.title;
    const author = i18n.language === 'de' && blog.Author_de ? blog.Author_de : blog.Author;
    const body = i18n.language === 'de' && blog.body_de ? blog.body_de : blog.body;
    const abstract = i18n.language === 'de' && blog.abstract_de ? blog.abstract_de : blog.abstract;
    const imageDescription =
        i18n.language === 'de' && blog.image_description_de
            ? blog.image_description_de
            : blog.image_description;

    return (
        <div className="blog-post">
            <div className="container">
                <article className="post-content" data-testid="content-article">
                    {blog.image && (
                        <>
                            <img
                                src={resolveImageUrl(blog.image)}
                                alt={title}
                                className="post-image"
                                loading="eager"
                                decoding="async"
                                width={1200}
                                height={675}
                            />
                            {imageDescription && (
                                <p
                                    className="post-image-description"
                                    dangerouslySetInnerHTML={{ __html: imageDescription }}
                                />
                            )}
                        </>
                    )}

                    <h1 className="post-title">{title}</h1>

                    <div className="post-meta">
                        {author && (
                            <div className="author-info">
                                {blog.author_image && (
                                    <img
                                        src={resolveImageUrl(blog.author_image)}
                                        alt={author}
                                        className="author-avatar"
                                        loading="lazy"
                                        decoding="async"
                                        width={80}
                                        height={80}
                                    />
                                )}
                                <span>{author}</span>
                            </div>
                        )}
                        {blog.created_at && (
                            <span className="post-date">
                                {new Date(blog.created_at).toLocaleDateString(i18n.language, {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                })}
                            </span>
                        )}
                    </div>

                    {abstract && (
                        <div className="post-abstract" dangerouslySetInnerHTML={{ __html: abstract }} />
                    )}
                    <div className="post-body" dangerouslySetInnerHTML={{ __html: body }} />
                </article>
            </div>
        </div>
    );
};
